import mainViewMixin from '../mainViewMixin';
import { mapState } from 'vuex';
export default {
  name: 'ViewNiotaClassicApplicationsApplicationsList',
  mixins: [mainViewMixin],
  data: function () {
    return {
      isLoadingAccounts: true,
      selectedAccounts: []
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    headerBG() {
      return './img/consumer.png';
    }
  },
  watch: {},
  methods: {
    updateList() {
      this.$refs.list.fetchList();
    },
    resetFilter() {
      this.selectedAccounts = [];
    }
  }
};